module.exports = __webpack_public_path__ + "media/images/athletes/1785-480f54bb85783924e86e1d16f1b60641.png";